import skeletonFade from '../../../../../../modules/mixins/skeleton-fade'
import styled from 'styled-components'

const SkeletonImageInstaWeather = styled.div`
  background-color: ${props => props.theme.color.skeletonScreen};
  ${skeletonFade};
`

export default SkeletonImageInstaWeather
